import {Component, inject, Input, OnInit, ViewChild} from '@angular/core';
import {FormsModule, NgForm} from "@angular/forms";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {NotFoundComponent} from "../../../../../shared/not-found/not-found.component";
import {ArbitraryEmailDto} from "../../../../../../generated-model/model";
import {SharedCommonModule} from "../../../../../shared/commons/shared-common.module";
import {emailPattern, markInvalidControlsAsDirtyAndTouched} from "../../../../../app.constants";
import {ArbitraryEmailResource} from "../../../../../service/ArbitraryEmailResource";
import {ToastService} from "../../../../../shared/commons/toast/toast-service";

@Component({
  selector: 'app-manage-email-modal',
  standalone: true,
  imports: [
    FormsModule,
    NotFoundComponent,
    SharedCommonModule
  ],
  templateUrl: './manage-email-modal.component.html',
  styleUrl: './manage-email-modal.component.scss'
})
export class ManageEmailModalComponent implements OnInit {
  @Input() item: ArbitraryEmailDto
  emailInput: string;
  activeModal = inject(NgbActiveModal);
  protected readonly emailPattern = emailPattern;
  @ViewChild("form", {read: NgForm, static: true}) form: NgForm;
  arbitraryEmailResource = inject(ArbitraryEmailResource);
  toastService = inject(ToastService);

  ngOnInit(): void {
  }

  submit() {
    let formValid = this.updateFormAndValidity(this.form);
    if (formValid) {
      this.arbitraryEmailResource.save(this.item).subscribe(e => {
        this.toastService.showSuccess('บันทึกสำเร็จ');
        this.activeModal.close(e);
      });
    }
  }

  remove(item: string) {
    this.item.emails = this.item.emails.filter(e => e !== item);
  }

  updateFormAndValidity(form: NgForm): boolean {
    if (!form.valid) {
      markInvalidControlsAsDirtyAndTouched(form)
    }
    return form.valid
  }

  add() {
    if (this.emailInput?.trim()) {
      let formValid = this.updateFormAndValidity(this.form);
      if (formValid) {
        this.item.emails ??= [];
        this.item.emails.push(this.emailInput);
        delete this.emailInput;
      }
    }
  }
}
